
import React from 'react';
import { FaFacebookF, FaYoutube, FaWhatsapp } from 'react-icons/fa'; 

function FloatingSocialButtons() {
  return (
    <div className="floating-social-buttons">
      <a
        href="https://web.facebook.com/profile.php?id=100035002704195"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-social-button facebook"
        aria-label="Facebook"
      >
        <FaFacebookF />
      </a>
      <a
        href="https://www.youtube.com/@kasiwaththaassociates7554"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-social-button youtube"
        aria-label="YouTube"
      >
        <FaYoutube />
      </a>
      <a
        href="https://wa.me/94773454333"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-social-button whatsapp"
        aria-label="WhatsApp"
      >
        <FaWhatsapp />
      </a>
    </div>
  );
}

export default FloatingSocialButtons;